import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiViewModule as e}from"@mdi/js";const i=({id:i="cards-view",title:o="Cards view",...m})=>t.createElement(r,{id:i,title:o,path:e,...m});export{i as CardsViewIcon};
